<div class="ui segment" [class.loading]="showSpinner">
  <gd-segment-header [text]="'txt_company_name_field_label' | translate"> </gd-segment-header>
  <p *ngIf="client?.description">{{ client.description }}</p>
  <p *ngIf="!client?.description && client?.name">{{ client.name }}</p>
  <p *ngIf="!client?.name && !client?.description">&nbsp;</p>
</div>
